export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/wasm-module-2.4654e4e78dcd9543.js");
}
